var exports = {
  "MO": "VoiceParticipantItem.module__participantRow___UDZjVX",
  "Kq": "VoiceParticipantItem.module__participantRowSpeaking___UDZjVX",
  "JN": "VoiceParticipantItem.module__participantRowDragging___UDZjVX",
  "z": "VoiceParticipantItem.module__participantRowCurrentConnection___UDZjVX",
  "B$": "VoiceParticipantItem.module__participantRowPopoutOpen___UDZjVX",
  "K0": "VoiceParticipantItem.module__participantRowContextMenuActive___UDZjVX",
  "Kt": "VoiceParticipantItem.module__deviceIcon___UDZjVX",
  "iY": "VoiceParticipantItem.module__deviceIconSpeaking___UDZjVX",
  "ns": "VoiceParticipantItem.module__deviceIconCurrent___UDZjVX",
  "zc": "VoiceParticipantItem.module__iconContainer___UDZjVX",
  "F8": "VoiceParticipantItem.module__participantName___UDZjVX",
  "xr": "VoiceParticipantItem.module__participantNameSpeaking___UDZjVX",
  "S$": "VoiceParticipantItem.module__participantNameCurrent___UDZjVX",
  "_q": "VoiceParticipantItem.module__iconsContainer___UDZjVX",
  "nt": "VoiceParticipantItem.module__flexShrinkZero___UDZjVX",
};

module.exports = exports;
